<template>
  <div>
      <hr/>
      <div class="text-right">
          <el-row>
              <el-button class='button_bv' :disabled="isProcessing" @click="cancelSaisieBV = true">{{ $t("posts.edit.cancel") }}</el-button>
              <el-dropdown :disabled="isProcessing" @command="handleCommand">
                  <el-button class='button_bv' type="primary" :disabled="isProcessing" :loading="isProcessing">
                    {{ $t("posts.edit.save") }}...<em class="el-icon-arrow-down el-icon--right"></em>
                  </el-button>
                  <el-dropdown-menu>
                      <el-dropdown-item command="saveAndClose">
                          {{ $t('posts.bienVendu.formCreation.saveAndClose') }}
                      </el-dropdown-item>
                      <el-dropdown-item command="saveAndManagePosts" >
                          {{ $t('posts.bienVendu.formCreation.saveAndManagePosts') }}
                      </el-dropdown-item>
                      <el-dropdown-item command="saveAndManageDiffusion">
                          {{ $t('posts.bienVendu.formCreation.saveAndManageDiffusion') }}
                      </el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
          </el-row>
      </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ButtonBienVendu',
  props: ['post', 'isProcessing'],
  data () {
    return {
      cancelSaisieBV: false
    }
  },
  methods: {
    handleCommand (command) {
      this.$emit('handleCommand', { action: command, post: this.post }) // parent is in charge
    }
  },
  computed: {
    ...mapState('postsListImmo', ['filter']),
    ...mapGetters(['isSubUser', 'isImmo', 'isVo', 'isPromoteur', 'isCmi']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  }
}
</script>
